export enum WEBHOOKS_ENDPOINT_TOPIC {
    SUBSCRIPTION_CANCELED = 'subscription.canceled',
}

export type WebhookEndpoint = {
    id: string;
    url: string;
    description: string;
    topics: WEBHOOKS_ENDPOINT_TOPIC[];
    secret: string;
    is_active: boolean;
    created_at: string;
    modified_at: string;
};

type WebhookTopicObject = {
    payload_type: string;
    schema: {
        type: string;
        required: string[];
        properties: {
            subscription_id: {
                type: string;
            };
            subscription_end_date: {
                type: string;
            };
        };
    };
};

export type WebhookTopics = Record<string, WebhookTopicObject>;
